import ListUsersB2b from '../../components/ListUsersB2b';

 function EspaceB2b() {
  return (
    <div>
<h2 className='mt-5'>Utilisateurs B2B</h2>
      <ListUsersB2b />
    </div>
  );
}

export default EspaceB2b